import type { Conversation, ConversationMeta } from '@/types/conversation'

export function parseConversationMeta(meta: string | undefined): ConversationMeta | null {
  if (!meta) return null
  try {
    return JSON.parse(meta) as ConversationMeta
  } catch {
    return null
  }
}

export function isWhatsAppOrigin(conv: Pick<Conversation, 'twilio_id'>): boolean {
  return conv.twilio_id?.startsWith('wa-') ?? false
}
